export const StateDetails = [
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_1',
    state_name: 'Andaman & Nicobar Islands'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_2',
    state_name: 'Andhra Pradesh'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_3',
    state_name: 'Arunachal Pradesh'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_4',
    state_name: 'Assam'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_5',
    state_name: 'Bihar'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_6',
    state_name: 'Chandigarh'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_7',
    state_name: 'Chhattisgarh'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_8',
    state_name: 'Dadra and Nagar Haveli and Daman and Diu'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_9',
    state_name: 'Delhi'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_10',
    state_name: 'Goa'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_11',
    state_name: 'Gujarat'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_12',
    state_name: 'Haryana'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_13',
    state_name: 'Himachal Pradesh'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_14',
    state_name: 'Jammu & Kashmir'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_15',
    state_name: 'Jharkhand'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_16',
    state_name: 'Karnataka'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_17',
    state_name: 'Kerala'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_18',
    state_name: 'Ladakh'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_19',
    state_name: 'Lakshadweep'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_20',
    state_name: 'Madhya Pradesh'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_21',
    state_name: 'Maharashtra'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_22',
    state_name: 'Manipur'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_23',
    state_name: 'Meghalaya'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_24',
    state_name: 'Mizoram'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_25',
    state_name: 'Nagaland'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_26',
    state_name: 'Odisha'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_27',
    state_name: 'Puducherry'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_28',
    state_name: 'Punjab'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_29',
    state_name: 'Rajasthan'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_30',
    state_name: 'Sikkim'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_31',
    state_name: 'Tamil Nadu'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_32',
    state_name: 'Telangana'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_33',
    state_name: 'Tripura'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_34',
    state_name: 'Uttar Pradesh'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_35',
    state_name: 'Uttarakhand'
  },
  {
    country_id: 'COUNTRY_97',
    state_id: 'STATE_IND_36',
    state_name: 'West Bengal'
  }
];
